export const TOP_10_RISKS = 'TOP_10_RISKS';
export const TOP_10_MALICIOUS_TRAFFIC = 'TOP_10_MALICIOUS_TRAFFIC';
export const ENTITY_WITH_HIGHEST_AV = 'ENTITY_WITH_HIGHEST_AV';
export const TOP_UNUSUAL_PARENTS = 'TOP_UNUSUAL_PARENTS';
export const LOW_HOST_COUNT_AND_HIGH_ACCESS_COUNT = 'LOW_HOST_COUNT_AND_HIGH_ACCESS_COUNT';
export const HOSTS_WITH_MALICIOUS_NETWORK = 'HOSTS_WITH_MALICIOUS_NETWORK';
export const HOSTS_WITH_MALICIOUS_FILE = 'HOSTS_WITH_MALICIOUS_FILE';
export const USERS_WITH_MOST_HOSTS_CONNECTIONS = 'USERS_WITH_MOST_HOSTS_CONNECTIONS';
export const NEWEST_LOCAL_USERS = 'NEWEST_LOCAL_USERS';
export const SET_HOSTS_MAP_DATA = 'SET_HOSTS_MAP_DATA';
export const SET_ELASTIC_GLOBAL_URL = 'SET_ELASTIC_GLOBAL_URL';
export const SHOW_HOSTS_MAP = 'SHOW_HOSTS_MAP';
